import { render, staticRenderFns } from "./BDXWizard.vue?vue&type=template&id=24b62352"
import script from "./BDXWizard.vue?vue&type=script&lang=js"
export * from "./BDXWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports